/* eslint-disable no-duplicate-case */
import React from 'react';
import {Redirect} from 'react-router-dom';
import {withNavigationWatcher} from '../../../contexts/navigation';
import Orders from '../../../pages/Orders/index';
import OrderAlert from '../../../pages/Orders/ordered-alert/ordered-alert';


const ordersRoutes = [
    {
        path: '/orders',
        component: () => {return(<Redirect to="/orders/awaiting-shipment"/>);}
    },{
        path: '/orders/awaiting-payment',
        component: () => {return (<Orders status={'awaiting-payment'}/>)}
    }, {
        path: '/orders/on-hold',
        component: () => { return (<Orders status={'on-hold'}/>)}
    }, {
        path: '/orders/awaiting-shipment',
        component: () => {return (<Orders status={'awaiting-shipment'}/>)}
    }, {
        path: '/orders/shipped',
        component: () => {return (<Orders status={'shipped'}/>)}
    }, 
    {
        path: '/orders/cancelled',
        component: () => {return (<Orders status={'cancelled'}/>)}
    }, {
        path: '/orders/ordered-alert',
        component: () => {return (<OrderAlert/>)}
    },{
        path: `/orders/awaiting-payment/manual-orders`,
        component: () => (<Orders status={'awaiting-payment'} store={'manual-orders'}/>)
    }, {
        path: `/orders/on-hold/manual-orders`,
        component: () => (<Orders status={'on-hold'} store={'manual-orders'}/>)
    }, {
        path: `/orders/awaiting-shipment/manual-orders`,
        component: () => (<Orders status={'awaiting-shipment'} store={'manual-orders'}/>)
    }, {
        path: `/orders/shipped/manual-orders`,
        component: () => (<Orders status={'shipped'} store={'manual-orders'}/>)
    }, {
        path: `/orders/cancelled/manual-orders`,
        component: () => (<Orders status={'cancelled'} store={'manual-orders'}/>)
    },
    {
        path: `/orders/awaiting-payment/ebay/:storeName`,
        component: () => (<Orders status={'awaiting-payment'} store={'ebay'}/>)
    }, {
        path: `/orders/on-hold/ebay/:storeName`,
        component: () => (<Orders status={'on-hold'} store={'ebay'}/>)
    }, {
        path: `/orders/awaiting-shipment/ebay/:storeName`,
        component: () => (<Orders status={'awaiting-shipment'} store={'ebay'}/>)
    }, {
        path: `/orders/shipped/ebay/:storeName`,
        component: () => (<Orders status={'shipped'} store={'ebay'}/>)
    }, {
        path: `/orders/cancelled/ebay/:storeName`,
        component: () => (<Orders status={'cancelled'} store={'ebay'}/>)
    },{
        path: `/orders/awaiting-payment/etsy/:storeName`,
        component: () => (<Orders status={'awaiting-payment'} store={'etsy'}/>)
    }, {
        path: `/orders/on-hold/etsy/:storeName`,
        component: () => (<Orders status={'on-hold'} store={'etsy'}/>)
    }, {
        path: `/orders/awaiting-shipment/etsy/:storeName`,
        component: () => (<Orders status={'awaiting-shipment'} store={'etsy'}/>)
    }, {
        path: `/orders/shipped/etsy/:storeName`,
        component: () => (<Orders status={'shipped'} store={'etsy'}/>)
    }, {
        path: `/orders/cancelled/etsy/:storeName`,
        component: () => (<Orders status={'cancelled'} store={'etsy'}/>)
    },{
        path: `/orders/awaiting-payment/shopify/:storeName`,
        component: () => (<Orders status={'awaiting-payment'} store={'shopify'}/>)
    }, {
        path: `/orders/on-hold/shopify/:storeName`,
        component: () => (<Orders status={'on-hold'} store={'shopify'}/>)
    }, {
        path: `/orders/awaiting-shipment/shopify/:storeName`,
        component: () => (<Orders status={'awaiting-shipment'} store={'shopify'}/>)
    }, {
        path: `/orders/shipped/shopify/:storeName`,
        component: () => (<Orders status={'shipped'} store={'shopify'}/>)
    }, {        
        path: `/orders/cancelled/shopify/:storeName`,
        component: () => (<Orders status={'cancelled'} store={'shopify'}/>)
    },{
        path: `/orders/awaiting-payment/amazon/:storeName`,
        component: () => (<Orders status={'awaiting-payment'} store={'amazon'}/>)
    }, {
        path: `/orders/on-hold/amazon/:storeName`,
        component: () => (<Orders status={'on-hold'} store={'amazon'}/>)
    }, {
        path: `/orders/awaiting-shipment/amazon/:storeName`,
        component: () => (<Orders status={'awaiting-shipment'} store={'amazon'}/>)
    }, {
        path: `/orders/shipped/amazon/:storeName`,
        component: () => (<Orders status={'shipped'} store={'amazon'}/>)
    }, {        
        path: `/orders/cancelled/amazon/:storeName`,
        component: () => (<Orders status={'cancelled'} store={'amazon'}/>)
    }
]

export default ordersRoutes.map(route => {
    return {
        ...route,
        component: withNavigationWatcher(route.component)
    };
});
